import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Constants, masterTransactionsTableTabName, tableName, transactionstableTabName } from '../../utilities/Constants';
import { CoreService } from '@charlesschwab/sac-ui-core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'mm-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() gridApi: GridApi | undefined | null;
  @Input() fileName: string;
  @Input() showPaginationMessage: boolean = true;
  @Input() showInfoIcon: boolean;
  @Output() pageChanged = new EventEmitter<boolean>();
  destroy$: Subject<void> = new Subject();
  nextPageIndicator: boolean = false;
  prevPageIndicator: boolean = false;
  tableName: tableName;
  tabName: transactionstableTabName | masterTransactionsTableTabName;
  pageSize: string = "10";

  constructor(
      private coreService: CoreService,
  ){}

  ngOnInit(): void {
    this.coreService.currentContextUpdated$
      .pipe(takeUntil(this.destroy$))
      .subscribe((context) => {
        this.onPageSizeChanged("10");
        this.tabName = 'All';
      });
  }

  ngOnChanges() {
    if (this.fileName) {
      let fileNameArr = new Array();
      if(this.fileName.toLowerCase().includes("master")){
        if(this.fileName.toLowerCase().includes("transactionstatus")){
          fileNameArr = ['master', 'Transaction Status'];
        } else if(this.fileName.toLowerCase().includes("recurring")){
          fileNameArr = ['master', 'Recurring'];
        }
      }
      else {
      fileNameArr = this.fileName.split('-');
      }
      this.tableName = fileNameArr[0] === 'pending' ? 'init' : fileNameArr[0] as tableName;
      this.tabName = (fileNameArr[1][0]?.toUpperCase() + fileNameArr[1]?.slice(1)) as transactionstableTabName | masterTransactionsTableTabName;
    }
  }

  onPageSizeChanged(newSize: string) {
    this.pageSize = newSize;
    this.gridApi?.setGridOption("paginationPageSize", (Number(this.pageSize)));
    this.pageChanged.emit(true);
  }

  onPageChanged(newPageNumber: string) {
    this.gridApi?.paginationGoToPage(Number(newPageNumber)-1);
    this.pageChanged.emit(true);
  }

  onBtNext() {
    this.gridApi?.paginationGoToNextPage();
    this.pageChanged.emit(true);
  }

  onBtPrev() {
    this.gridApi?.paginationGoToPreviousPage();
    this.pageChanged.emit(true);
  }

  get pageNumber(): number {
    return this.gridApi ? this.gridApi.paginationGetCurrentPage()+1 : 0;
  }

  get numberOfPages(): number {
    return this.gridApi?.paginationGetTotalPages() ?? 0;
  }

  get checkPrevButtonIndicator() {
    return this.pageNumber && this.pageNumber > 1;
  }

  get checkNextButtonIndicator() {
    return this.pageNumber && this.numberOfPages && this.pageNumber < this.numberOfPages;
  }

  get totalResults(): number {
    let displayedRows = 0;
    this.gridApi?.forEachNodeAfterFilter(() => displayedRows++);
    return displayedRows;
  }

  displayCreateRuleTooltip(): boolean {
    return !!(this.tableName === 'create rule')
  }

  get tooltipVerbiage(): string {
      return Constants.createRuleTooltipPopupMessage;
    }

  get paginationMessage(): string {
    if(!this.showPaginationMessage){
     return '';
    }
    else if (this.tableName === 'init') {
        return Constants.initReleasePaginationDisclaimer;
    }
    else if (this.tableName === 'create rule') {
      return Constants.createRulePaginationDisclaimer;
    }
    else if (this.tableName === 'recurring' || this.tableName === 'standing') {
      return '';
    }

    switch(this.tabName) {
      case 'All': return Constants.allTransactionsPaginationDisclaimer;
      case 'Upcoming': return Constants.upcomingPaginationDisclaimer;
      case 'Recent': return Constants.recentPaginationDisclaimer;
      case 'Transaction Status': return Constants.transactionStatusPaginationDisclaimer;
      default: return ''
    }
  }
}
